<template lang="pug">
.k-share.cursor-pointer
  .k-share__native(v-if="isShareAvailable" @click="shareLink").d-inline-block
    slot
  .k-share__copy(v-else v-clipboard:copy="link" v-clipboard:success="linkCopied").d-inline-block
    slot
  v-fade-transition
    span(v-if="copied").pl-2 Copied!
</template>

<script>
import { SHARE, push } from '@/lib/gtm'

export default {
  props: {
    link: {
      type: String,
      required: true
    },
    showToast: {
      type: Boolean,
      default: true,
    },
    showCopied: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: false,
      default: '',
    }
  },
  data () {
    return {
      isShareAvailable: navigator.share,
      copied: false,
    }
  },
  methods: {
    shareLink () {
      try {
        navigator.share({
          url: this.link,
        })
        push(SHARE.NATIVE, {
          shareUrl: this.link,
          title: this.title,
          text: this.text,
        })
        this.$emit('share')
      } catch (e) {
        // they probably cancelled the share
        this.$logger.error(e)
      }
    },
    linkCopied () {
      push(SHARE.COPY, {
        shareUrl: this.link
      })
      this.$emit('copy')
      if (this.showToast) {
        this.$toast.success('Link Copied!')
      }
      if (this.showCopied) {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 3000)
      }
    },
  }
}
</script>
